import { render, staticRenderFns } from "./tableFinances.vue?vue&type=template&id=1a9ba43b&scoped=true&"
import script from "./tableFinances.vue?vue&type=script&lang=js&"
export * from "./tableFinances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9ba43b",
  null
  
)

export default component.exports